const iconsList = [
  {
    title: 'Linkedin',
    imgUrl: 'linkedin',
    url: 'https://www.linkedin.com/in/amrsaadabdallah',
    target: '_blank',
  },
  {
    title: 'github',
    imgUrl: 'github',
    url: 'https://github.com/amrsaadabdallah',
    target: '_blank',
  },
  {
    title: 'Email',
    imgUrl: 'email',
    url: 'mailto:amrsaadabdallah@gmail.com',
    target: '_self',
  },
  {
    title: 'phone',
    imgUrl: 'phone',
    url: 'tel:+201097756067',
    target: '_self',
  },
  {
    title: 'twitter',
    imgUrl: 'twitter',
    url: 'https://twitter.com/amrsaadabdallah',
    target: '_blank',
  },
];

export default iconsList;
